export default __webpack_public_path__ + "static/media/ISGB.367495cf.jpg";